import React from 'react';
// import format from 'date-fns/format';
// import { DayPicker } from 'react-day-picker';
import classNames from 'classnames';
import { useField } from 'formik';
import Label from '../lib/Label';
import Error from '../lib/Error';
import Container from '../lib/Container';

import 'react-day-picker/dist/style.css';

export default function DateInput(props) {

    const {
        label,
        name,
        type = "date",
        autoComplete,
        disabled,
        onChange,
        onBlur,
        step,
        placeholder,
        readOnly,
        fieldId,
        columns,
        required
    } = props;

    const [field, meta] = useField({
        name,
        readOnly,
        type,
        id: fieldId || name,
        autoComplete
    });

    const InputClasses = classNames({
        "block": true,
        "w-full": true,
        "rounded-xl": true,
        "border-line": !meta?.error,
        "shadow-sm": true,
        "focus:z-10": true,
        "focus:border-primary": true,
        "disabled:bg-light": true,
        "disabled:cursor-not-allowed": true,
        "disabled:opacity-30": true,
        "has-error": meta?.error
    })

    function onChangeHandler(event) {
        const value = event.target.value;

        if (onChange && typeof onChange === 'function') {
            onChange(value, name)
        }

        return field.onChange(event);
    }

    function onBlurHandler(event) {

        const value = event.target.value;

        if (onBlur && typeof onBlur === 'function') {
            onBlur(value, name)
        }

        return field.onBlur(event);
    }

    // const FalseInputClasses = classNames({
    //     "block w-full h-input rounded-xl shadow-sm bg-white rounded-md border": true,
    //     "border-primary": focused,
    //     'border-line': !focused && !meta?.error,
    //     "bg-light cursor-not-allowed opacity-30": disabled,
    //     "border-red": meta?.error,
    // })

    // const PopupClasses = classNames({
    //     "absolute top-50 left-0 z-10 bg-white border border-line rounded-md drop-shadow": true,
    //     "block": focused,
    //     "hidden": !focused
    // })

    // const onSelectDayHandler = (day) => {
    //     field.onChange({
    //         target: {
    //             name: name,
    //             value: day
    //         }
    //     })
        

    //     if (onChange && typeof onChange === 'function') {
    //         onChange(day, name)
    //     }

    //     field.onChange(event);

    //     return setFocused(false);
    // }

    return (
        <Container columns={columns || 1}>
            {label &&
                <Label
                    label={label}
                    name={name}
                    fieldId={fieldId}
                    focused={true}
                    required={required}
                />
            }

            <input 
                {...field}
                type={type}
                disabled={disabled}
                className={InputClasses}
                placeholder={placeholder}
                onChange={onChangeHandler}
                onBlur={onBlurHandler}
                step={step}
            />

            {/* <div
                className={FalseInputClasses}
                onClick={() => setFocused(true)}
            >
                <div className='w-full flex h-50 items-center px-3'>
                    {field?.value && format(field?.value, 'dd/MM/yyyy')}
                </div>
            </div>

            <div className={PopupClasses}>
                <DayPicker
                    mode="single"
                    selected={field?.value}
                    onSelect={onSelectDayHandler}
                    disabled={disabled}
                />
            </div> */}

            {meta?.error && (
                <Error error={meta.error}/>
            )}
        </Container>
    )
}
